import { render, staticRenderFns } from "./swiperPage.vue?vue&type=template&id=11b2311f&scoped=true"
import script from "./swiperPage.vue?vue&type=script&lang=js"
export * from "./swiperPage.vue?vue&type=script&lang=js"
import style0 from "./swiperPage.vue?vue&type=style&index=0&id=11b2311f&prod&lang=scss&scoped=true"
import style1 from "./swiperPage.vue?vue&type=style&index=1&id=11b2311f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b2311f",
  null
  
)

export default component.exports